<ejs-dropdownlist
  id="tankField"
  #tankField
  [dataSource]="options"
  [fields]="fields"
  [enableVirtualization]="true"
  (change)="onTankChange($event)"
  [enabled]="!disabled"
  cssClass="e-outline"
  [allowFiltering]="true"
  [noRecordsTemplate]="'No Tanks Found'"
  [filterType]="'contains'"
  [placeholder]="'General.SelectTank' | translate"
>
</ejs-dropdownlist>
<!-- spinner overlay when control is loading options -->
<div *ngIf='loading' class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
